export const getDayTitle = (date) => {
  const lastNumber = date % 10;
  let valueDay;
  if (lastNumber === 1) valueDay = 'день';
  else if (lastNumber >= 2 && lastNumber <= 4) valueDay = 'дня';
  else valueDay = 'дней';
  return `${date} ${valueDay}`;
};
